// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dL9Rt","content":"styles_content__NwKBN","leftSide":"styles_leftSide__DcnGc","enableEdit":"styles_enableEdit__HERL6"};